import React, { FC } from 'react';

type Props = {
  children?: React.ReactNode;
};

const LinkGroup: FC<Props> = ({ children }) => {
  return <div className="mb-5">{children}</div>;
};

export default LinkGroup;
